/**
 * <s-countdown> — counts down to a fixed deadline.
 * Attributes:
 *   end — ISO 8601 deadline (e.g. 2026-10-31T23:59:59-04:00).
 * Children with data-unit="days|hours|minutes|seconds" receive zero-padded values.
 * When the deadline passes, the element closest to [data-countdown-region] is hidden,
 * and any sibling marked [data-countdown-fallback] is revealed.
 */
class SCountdown extends HTMLElement {
  #timer;

  connectedCallback() {
    this.end = Date.parse(this.getAttribute('end') || '');
    if (Number.isNaN(this.end)) return;
    this.#tick();
    this.#timer = setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.#timer);
  }

  #tick() {
    const remaining = this.end - Date.now();
    if (remaining <= 0) {
      clearInterval(this.#timer);
      const region = this.closest('[data-countdown-region]');
      if (region) {
        region.hidden = true;
        const fallback = region.parentElement?.querySelector('[data-countdown-fallback]');
        if (fallback) fallback.hidden = false;
      }
      return;
    }
    const total = Math.floor(remaining / 1000);
    const values = {
      days: Math.floor(total / 86400),
      hours: Math.floor((total % 86400) / 3600),
      minutes: Math.floor((total % 3600) / 60),
      seconds: total % 60,
    };
    for (const [unit, value] of Object.entries(values)) {
      const el = this.querySelector(`[data-unit="${unit}"]`);
      if (el) el.textContent = String(value).padStart(2, '0');
    }
  }
}

if (!customElements.get('s-countdown')) customElements.define('s-countdown', SCountdown);
